export function tabs() {
	let tabNav = $(".tab-nav a");
	let tabDescription = $(".tab-description .tab-item");

	tabNav.on("click", function (e) {
		e.preventDefault();
		let $this = $(this);
		let target = $this.attr("href");
		if (!$this.hasClass("active")) {
			tabNav.removeClass("active");
			tabDescription.slideUp(300);
			$this.addClass("active");
			$(target).slideDown(300);
		}
	});
	$(".tab-nav ul li:first a").trigger("click");
}


// WEBPACK FOOTER //
// ./assets/js/modules/tabs.js